const investTagThematiqueLang = {
	environment: {
		tag: 'invest.tag.thematique.environment',
		fr: 'Environnement',
		en: 'Environment',
	},
	social: {
		tag: 'invest.tag.thematique.social',
		fr: 'Social',
		en: 'Social',
	},
};

export default investTagThematiqueLang;
